<div class="container-fluid">
  <div mat-dialog-title>
    <div *ngIf="quoteAreaItem.quoteArea_ID == null" i18n>Add Product Item to Quote</div>
    <div *ngIf="quoteAreaItem.quoteArea_ID != null" i18n>Edit Product Item</div>
  </div>
  <div mat-dialog-content>
    <form #areaForm="ngForm" (ngSubmit)="saveArea(areaForm)">
      <p i18n>Please enter product information for quote area</p>

      <div class="form-group-row">
        <div class="form-inline">
          <input type="checkbox" name="area_IsCustomItem"
                 id="area_IsCustomItem" class="bidit-switch-sm ml-1 mr-1" [(ngModel)]="quoteAreaItem.area_IsCustomItem" />
          <label>Custom Item</label>
        </div>
      </div>

      <div *ngIf="quoteAreaItem.area_IsCustomItem" class="form-group row">
        <div class="col-sm-12 form-inline">
          <div class="control-wrapper">
            <label for="area_Name">Line Item Description</label>
            <input name="area_Name" type="Text" class="form-control" maxlength="50"
                   [(ngModel)]="quoteAreaItem.area_Name" #area_Name="ngModel" />
            <div [hidden]="!areaForm.submitted || area_Name.valid"
                 class="alert alert-danger" i18n>Enter an alias</div>
          </div>
          <div class="control-wrapper">
            <label for="area_Note">Product</label>
            <input name="area_Note" type="Text" class="form-control" maxlength="50"
                   placeholder="Enter Product Description"
                   [(ngModel)]="quoteAreaItem.area_Note" #area_Name="ngModel" />
            <div [hidden]="!areaForm.submitted || area_Note.valid"
                 class="alert alert-danger" i18n>Enter a product description</div>
          </div>
        </div>

        <div class="form-group row mt-3">
          <div class="col-sm-12 form-inline">
            <div class="control-wrapper">
              <label for="area_ItemCost" class="col-sm-4 col-form-label" i18n>Custom Item Cost</label>
              <input name="area_ItemCost" type="number" class="form-control"
                     message="Custom Item Cost must be numeric." placeholder="$ Enter cost" i18n-placeholder
                     [(ngModel)]="quoteAreaItem.area_ItemCost" #area_ItemCost="ngModel" />
            </div>
            <div class="control-wrapper" *ngIf="showAdditionalLabor">
              <label for="area_ExtraLabor" class="col-sm-4 col-form-label" i18n>Additional Labor</label>
              <input name="area_ExtraLabor" type="number" class="form-control"
                     message="Additional Labor must be numeric." placeholder="$ Enter additional labor" i18n-placeholder
                     [(ngModel)]="quoteAreaItem.area_ExtraLabor" #area_ExtraLabor="ngModel" />
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!quoteAreaItem.area_IsCustomItem" class="form-group row">
        <div class="col-sm-12 form-inline">
          <div *ngIf="quoteAreaItem.quoteAreaItem_ID==null && quoteArea.quoteArea_ID==null; then thenBlock else elseBlock" class="control-wrapper"></div>
          <ng-template #thenBlock>
            <span class="warning">* </span>
            <label for="area_ID" i18n>Area</label>
            <select name="area_ID" class="form-control select-bidit"
                    required=""
                    [(ngModel)]="quoteAreaItem.area_ID" #area_ID="ngModel" (ngModelChange)="onAreaChange($event)">
              <option *ngFor="let area of areas" [ngValue]="area.area_ID">{{area.area_Name}}</option>
            </select>
            <div [hidden]="!areaForm.submitted || area_ID.valid"
                 class="alert alert-danger" i18n>Select an area</div>
          </ng-template>
          <ng-template #elseBlock>
          </ng-template>

          <div class="control-wrapper">
            <span class="warning">* </span>
            <label class="col-form-label" for="subArea_ID" i18n>Sub Area</label>
            <ng-template [ngIf]="quoteArea && quoteArea.area">
              <select name="subArea_ID" class="form-control select-bidit"
                      required=""
                      [(ngModel)]="quoteAreaItem.subArea_ID" #subArea_ID="ngModel">
                <option [ngValue]="undefined">-</option>
                <option *ngFor="let subArea of quoteArea.area.subAreas" [ngValue]="subArea.subArea_ID">{{subArea.subArea_Name}}</option>
              </select>
              <div [hidden]="!areaForm.submitted || subArea_ID.valid"
                   class="alert alert-danger" i18n>Select a sub area</div>
            </ng-template>
            <ng-template [ngIf]="quoteArea && quoteArea.area == null">
              <div class="form-control" i18n>Select Area</div>
            </ng-template>
          </div>

          <div class="control-wrapper">
            <label for="area_Name">Alias</label>
            <input name="area_Name" type="Text" class="form-control" maxlength="50"
                   [(ngModel)]="quoteAreaItem.area_Name" #area_Name="ngModel" />
            <div [hidden]="!areaForm.submitted || area_Name.valid"
                 class="alert alert-danger" i18n>Enter an alias</div>
          </div>
          <div class="row form-inline" *ngIf="quoteArea && quoteArea.area && quoteArea.area.area_IsOption">
            <div class="form-inline mt-3">
              <mat-checkbox class="mr-5" id="isAreaOptionGroup" name="isAreaOptionGroup" [(ngModel)]="isAreaOptionGroup" i18n>Use Option Group</mat-checkbox>
              <ng-template class="control-wrapper " [ngIf]="isAreaOptionGroup">
                <label class="mx-2" for="selectedOptionGroup">Option Group</label>
                <select name="selectedOptionGroup" class="form-control select-bidit"
                        [(ngModel)]="quoteAreaItem.optionGroup" #selectedOptionGroup="ngModel">
                  <option [ngValue]=null>-</option>
                  <option [ngValue]=1>1</option>
                  <option [ngValue]=2>2</option>
                  <option [ngValue]=3>3</option>
                  <option [ngValue]=4>4</option>
                  <option [ngValue]=5>5</option>

                  <!--<option *ngFor="let qaOptionGroup of quoteArea.QuoteAreaOptionGroup" [ngValue]="qaOptionGroup.quoteAreaOptionGroup_ID">{{subArea.subArea_Name}}</option>-->
                </select>
              </ng-template>
            </div>
          </div>
        </div>
        <div class="form-group row mt-3">
          <label for="productFilterItemType_ID" class="col-sm-3 col-form-label">
            <span class="warning">* </span><span i18n>Product</span>
            <span class="float-right" i18n>Filter:</span>
          </label>
          <div class="col-sm-9 form-inline">
            <select name="productFilterItemType_ID" class="form-control select-bidit"
                    [(ngModel)]="productFilterItemType_ID" (ngModelChange)="refreshProductItemType()">
              <option value="undefined" selected="selected" disabled hidden i18n>Choose Item Type... </option>
              <option [ngValue]="undefined" style="color:black;"> - </option>
              <option *ngFor="let itemType of itemTypes" [ngValue]="itemType.itemType_ID">{{itemType.itemType_Desc}}</option>
            </select>
            <select *ngIf="!productUsage && !productAeroBarrier" name="productFilterRValue" class="form-control select-bidit"
                    [(ngModel)]="productFilterRValue" (ngModelChange)="refreshProductItems()">
              <option value="undefined" selected="selected" disabled="" hidden="" i18n>Choose R-Value... </option>
              <option [ngValue]="undefined" style="color:black;"> - </option>
              <option *ngFor="let rValue of productRValues" [ngValue]="rValue.rValue_ID">{{rValue.rValue_Desc}}</option>
            </select>
          </div>
        </div>

        <div class="form-group row">
          <label for="item_ID" class="col-sm-3 col-form-label"></label>
          <div class="col-sm-9 form-inline">
            <select id="item_ID" name="item_ID" class="form-control select-bidit"
                    required="" appValidateItemCost
                    [(ngModel)]="quoteAreaItem.item_ID" #item_ID="ngModel"
                    (ngModelChange)="refreshProductUsages()">
              <option [ngValue]="undefined" selected="selected"> - </option>
              <option *ngFor="let productItem of productItems" [ngValue]="productItem.item_ID">
                <ng-template [ngIf]="productItem.item_Part">{{productItem.item_Part}}, </ng-template>{{productItem.item_Name}}
              </option>
            </select>
            <div *ngIf="areaForm.submitted && areaForm.controls['item_ID']?.errors?.itemPriceValidator"
                 class="alert alert-danger">
              {{areaForm.controls['item_ID']?.errors.itemPriceValidator}}
            </div>
            <div *ngIf="productUsage">
              <span i18n>Coverage:</span>
              <select name="itemUsage_ID" class="form-control select-bidit"
                      required=""
                      [(ngModel)]="quoteAreaItem.itemUsage_ID" #itemUsage_ID="ngModel">
                <option [ngValue]="undefined" selected="selected"> - </option>
                <option *ngFor="let itemUsage of productUsages" [ngValue]="itemUsage.itemUsage_ID">{{itemUsage.rValue.rValue_Desc}}</option>
              </select>
              <div [hidden]="!areaForm.submitted || itemUsage_ID.valid"
                   class="alert alert-danger" i18n>Select a coverage</div>
            </div>
            <div [hidden]="!areaForm.submitted || !areaForm.controls['item_ID']?.errors?.required"
                 class="alert alert-danger" i18n>Select a product</div>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-sm-12 form-inline">
            <div class="control-wrapper">
              <label for="area_SqrFtg" class="col-sm-4 col-form-label">
                <span class="warning">* </span>
                <span i18n>Square Footage</span>
              </label>
              <input name="area_SqrFtg" type="number" class="form-control"
                     required=""
                     message="Square footage must be numeric."
                     [(ngModel)]="quoteAreaItem.area_SqrFtg" #area_SqrFtg="ngModel" />
              <div [hidden]="!areaForm.submitted || area_SqrFtg.valid"
                   class="alert alert-danger" i18n>Enter square footage</div>
            </div>
            <div class="control-wrapper" *ngIf="showAdditionalLabor">
              <label for="area_ExtraLabor" class="col-sm-4 col-form-label" i18n>Additional Labor</label>
              <input name="area_ExtraLabor" type="number" class="form-control"
                     message="Additional Labor must be numeric." placeholder="$ Enter additional labor" i18n-placeholder
                     [(ngModel)]="quoteAreaItem.area_ExtraLabor" #area_ExtraLabor="ngModel" />
            </div>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-sm-12 form-inline">
            <div class="control-wrapper">
              <label for="area_OtherCosts" class="col-sm-4 col-form-label" i18n>Additional Costs</label>
              <input name="area_OtherCosts" type="number" class="form-control"
                     message="Additional Costs must be numeric." placeholder="$ Enter additional costs" i18n-placeholder
                     [(ngModel)]="quoteAreaItem.area_OtherCosts" #area_OtherCosts="ngModel" />
            </div>
            <div class="control-wrapper">
              <label for="area_IsMaterialOnly" class="col-form-label" i18n>Material Only</label>
              <mat-radio-group name="area_IsMaterialOnly"
                               [(ngModel)]="quoteAreaItem.area_IsMaterialOnly">
                <mat-radio-button [value]="true" i18n>Yes</mat-radio-button>
                <mat-radio-button [value]="false" i18n>No</mat-radio-button>
              </mat-radio-group>
            </div>
            <div *ngIf="quoteArea.area != null && quoteArea.area.area_IsOption" class="control-wrapper">
              <label for="area_GrossMargin" class="col-form-label" i18n>Gross Margin %</label>
              <input name="area_GrossMargin" type="number" class="form-control"
                     [(ngModel)]="quoteAreaItem.area_GrossMargin" #area_GrossMargin="ngModel">
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="form-inline">
          <label for="lineItem_CustomNote" class="col-sm-4 col-md-1 col-form-label" i18n>Notes</label>
          <mat-checkbox class="example-margin" (change)="useTemplateChange($event.checked)">
            Use Template
          </mat-checkbox>
          <span  class="col-6">
            <select *ngIf="this.showTemplates" name="quoteItemNoteTemplate" class="ml-2 form-control select-bidit"
                    [(ngModel)]=this.selectedTemplate #quoteItemNoteTemplate_ID="ngModel" (ngModelChange)=quoteItemNoteTemplateChange($event)>
              <option [ngValue]=null selected="selected"> - </option>
              <option *ngFor="let template of data.quoteItemNoteTemplates" [ngValue]="template.quoteItemNoteTemplate_ID">{{template.quoteItemNoteTemplate_Name}}</option>
            </select>
            </span>
        </div>
        <div class="col-sm-8 col-md-11">
          <textarea class="form-control" name="lineItem_CustomNote" id="lineItem_CustomNote"
                    rows="3" maxlength="500"
                    [(ngModel)]="quoteAreaItem.area_ItemCustomNotes" #quoteAreaItem.area_ItemCustomNotes="ngModel">
          </textarea>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-sm-12">
          <table class="table table-bidit">

            <thead>
              <tr>
                <th i18n>Item</th>
                <th i18n>Cost</th>
                <th i18n>Quantity</th>
              </tr>
            </thead>
            <tbody>
              <ng-template [ngIf]="quoteAreaItem.accessories">
                <tr *ngIf="quoteAreaItem.accessories.length==0">
                  <td colspan="3" i18n>No defined accessories for selected area</td>
                </tr>
                <tr *ngFor="let areaItem of quoteAreaItem.accessories; let index = index;">
                  <td *ngIf="areaItem.item">
                    <strong>{{areaItem.item.item_Name}}</strong><br>
                    <!--{{areaItem.item.item_SalesDesc}}-->
                  </td>
                  <td *ngIf="!areaItem.item">
                    <input name="accessory_CustomName{{index}}" class="form-control"
                           [(ngModel)]="areaItem.accessory_CustomName" #accessory_CustomName="ngModel" required />
                    <div [hidden]="!areaForm.submitted || areaItem.accessory_CustomName" class="alert alert-danger" i18n>Enter a name</div>
                  </td>
                  <td *ngIf="areaItem.item && !data.showLinePricing">
                  </td>
                  <td *ngIf="areaItem.item && data.showLinePricing">
                    ${{areaItem.item.item_Cost == null ? 0 : areaItem.item.item_Cost  | number:'1.2-2'}}
                  </td>
                  <td *ngIf="!areaItem.item">
                    <input name="accessory_Cost{{index}}" type="number" class="form-control"
                           [(ngModel)]="areaItem.accessory_Cost" #accessory_Cost="ngModel" />
                  </td>
                  <td>
                    <input name="accessory_Quantity{{index}}" type="number" class="form-control"
                           [(ngModel)]="areaItem.accessory_Quantity" #accessory_Quantity="ngModel" />
                    <button *ngIf="!areaItem.item" type="button" class="btn btn-bidit-delete"
                            (click)="removeCustomAccessory(areaItem)" title="Remove custom accessory" i18n-title></button>
                  </td>
                </tr>
              </ng-template>
              <tr>
                <td colspan="2" i18n>Add custom accessory</td>
                <td>
                  <button type="button" class="btn btn-bidit-add" (click)="addCustomAccessory()" title="Add custom accessory" i18n-title></button>
                </td>
              </tr>
            </tbody>
          </table>

        </div>

      </div>
      <div class="row">
        <div class="col-sm-12">
          <div [hidden]="!areaForm.submitted || areaForm.valid"
               class="alert alert-danger" i18n>Validation issues encountered.  Please review your entered information.</div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4">
          <app-spinner [isRunning]="isRequesting"></app-spinner>
        </div>
        <div class="col-sm-8">
          <button type="submit" value="submit" name="submit" [disabled]="isRequesting" class="btn btn-bidit-submit mr-1" i18n>Submit</button>
          <button type="button" class="btn btn-bidit-cancel" (click)="cancelEdit()" i18n>Cancel</button>
        </div>
      </div>
    </form>
  </div>
</div>
